import React, { useState } from "react";
import {
  CardOutline,
  WalletOutline,
  PhonePortraitOutline,
  BasketOutline,
  QrCodeOutline,
  BusinessOutline,
  ClipboardOutline,
  CheckmarkCircleOutline,
  Trash,
  Close,
} from "react-ionicons";

const VectorIcons = ({
  name = "",
  cssClasses = "",
  height = "25px",
  width = "25px",
  onClick = null,
}) => {
  switch (name) {
    case "ios-card-outline":
      return (
        <CardOutline
          cssClasses={cssClasses}
          height={height}
          width={width}
          onClick={onClick}
        />
      );
    case "ios-wallet-outline":
      return (
        <WalletOutline
          cssClasses={cssClasses}
          height={height}
          width={width}
          onClick={onClick}
        />
      );
    case "ios-phone-portrait-outline":
      return (
        <PhonePortraitOutline
          cssClasses={cssClasses}
          height={height}
          width={width}
          onClick={onClick}
        />
      );
    case "md-basket-outline":
      return (
        <BasketOutline
          cssClasses={cssClasses}
          height={height}
          width={width}
          onClick={onClick}
        />
      );
    case "qr-code-outline":
      return (
        <QrCodeOutline
          cssClasses={cssClasses}
          height={height}
          width={width}
          onClick={onClick}
        />
      );
    case "ios-business-outline":
      return (
        <BusinessOutline
          cssClasses={cssClasses}
          height={height}
          width={width}
          onClick={onClick}
        />
      );
    case "md-clipboard-outline":
      return (
        <ClipboardOutline
          cssClasses={cssClasses}
          height={height}
          width={width}
          onClick={onClick}
        />
      );
    case "checkmark-circle-outline":
      return (
        <CheckmarkCircleOutline
          cssClasses={cssClasses}
          height={height}
          width={width}
          onClick={onClick}
        />
      );
    case "close":
      return (
        <Close
          cssClasses={cssClasses}
          height={height}
          width={width}
          onClick={onClick}
        />
      );
    case "trash":
      return (
        <Trash
          color={"#E30000"}
          cssClasses={cssClasses}
          height={height}
          width={width}
          onClick={onClick}
        />
      );

    default:
      return null;
  }
};

export default VectorIcons;
